export default {
  buttons: {
    remove: 'Entfernen',
  },
  title: 'Promo-Code oder Geschenkkarte',
};
